import React from 'react';
import {makeStyles} from "@material-ui/core/styles";

import {Button, Dialog, DialogTitle, DialogContent, TextField as TextFieldMaterial, DialogActions} from "@material-ui/core"
import { useMutation, useNotify, useRefresh} from 'react-admin';


const useStyles = makeStyles((theme) => ({
    rootContent: {
        
    },
}));

const DialogComponent = (props) => {
    const notify = useNotify();
    const classes = useStyles();
    const refresh = useRefresh()
    const {maxWidth = "md", product = {}, record = {}, id, classesContent = {}, handleClose, title, children, ...rest} = props;
    const [price, setPrice] = React.useState(product.aw.agency_price)
    const handleChange = (e) => {
        setPrice(e.target.value)
    }
    const [handleSubmit] = useMutation(
        {
            type: 'update',
            resource: 'warehouseagencies',
            payload: { data: {sale_price: Number(price), product_id: product.id, agency_id: id} },
        },
        {
            undoable: false,
            onSuccess: ({ data, status, message }) => {
                if(status) {
                    notify('Done', 'info', {}, false);
                    refresh()
                    handleClose()
                } else {
                    notify(`Error: ${message}`, 'warning')
                }
            },
            onFailure: (error) => notify(`Error: ${error.message}`, 'warning'),
        }
    );
    return (
        <Dialog {...rest} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{title}</DialogTitle>
            <DialogContent classes={{
                ...classesContent,
                root: classes.rootContent,
            }} maxWidth={maxWidth}> 
                <TextFieldMaterial label="Price" name="price" value={price} type="number" fullWidth onChange={handleChange}/>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit}>Save</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogComponent;
